import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";
import { getData, serverURL } from "../../../Services/Fetchnodeservices.js";

export default function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [showMore, setShowMore] = useState(false);
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch certificates from API
  useEffect(() => {
    const fetchCertificates = async () => {
      try {
        const response = await getData("footercertificatee/fetch_all_footer_certificate");
        console.log("Certificates API Response:", response);

        let certificatesData = [];
        if (response && response.status === true && response.data) {
          certificatesData = response.data;
        } else if (Array.isArray(response)) {
          certificatesData = response;
        } else if (response?.data && Array.isArray(response.data)) {
          certificatesData = response.data;
        }

        // Filter only active certificates (status = 1 and hide = 0)
        const activeCertificates = certificatesData.filter(
          cert => cert.status === "1" || cert.status === 1 && cert.hide === "0" || cert.hide === 0
        );
        
        setCertificates(activeCertificates);
      } catch (err) {
        console.error("Error fetching certificates:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificates();
  }, []);

  // Navigation handlers
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Get image URL function
  const getImageUrl = (picName) => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") {
      return null;
    }
    if (picName.startsWith('http')) {
      return picName;
    }
    let filename = picName;
    if (filename.includes('/')) {
      filename = filename.split('/').pop();
    }
    if (filename.includes('\\')) {
      filename = filename.split('\\').pop();
    }
    return `${serverURL}/uploadnew/upload/${filename}`;
  };

  return (
    <footer style={styles.footer}>
      {/* TOP SECTION */}
      <div style={styles.topSection}>
        {/* LEFT SIDE */}
        <div style={styles.logoSection}>
          <img
            src="https://zaptodoor.com/upload/file_697cd2ac092d56.33530713.png"
            alt="Zaptodoor Logo"
            style={{ ...styles.logo, cursor: "pointer" }}
            onClick={() => handleNavigation("/")}
          />

          {/* SMALL SLIDER - CERTIFIED PARTNERS */}
          <div style={{ marginTop: "26px" }}>
            <h3 style={styles.heading}>Certified Partners</h3>
            {loading ? (
              <div style={sliderStyles.loading}>
                <div style={sliderStyles.loader} />
                <p style={{ fontSize: "12px", marginTop: "8px" }}>Loading...</p>
              </div>
            ) : certificates.length > 0 ? (
              <HorizontalSlider images={certificates} getImageUrl={getImageUrl} />
            ) : (
              <div style={sliderStyles.empty}>
                <p style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)" }}>
                  No certificates available
                </p>
              </div>
            )}
          </div>
        </div>

        {/* COMPANY */}
        <div style={styles.column}>
          <h3 style={styles.heading}>Company</h3>
          <ul style={styles.list}>
            <li onClick={() => handleNavigation("/About")}>About Us</li>
            <li onClick={() => handleNavigation("/services")}>Our Services</li>
            <li onClick={() => handleNavigation("/vendor-partner")}>Vendor Partner</li>
            <li onClick={() => handleNavigation("/delivery-partner")}>Delivery Partner</li>
            <li onClick={() => handleNavigation("/OurCertifications")}>Our Certifications</li>
          </ul>
        </div>

        {/* LEGAL */}
        <div style={styles.column}>
          <h3 style={styles.heading}>Legal</h3>
          <ul style={styles.list}>
            <li onClick={() => handleNavigation("/PrivacyPolicy")}>Privacy Policy</li>
            <li onClick={() => handleNavigation("/Cancellationpolicy")}>Cancellation Policy</li>
            <li onClick={() => handleNavigation("/TermsAndConditions")}>Terms & Conditions</li>
            <li onClick={() => handleNavigation("/ShippingPolicy")}>Shipping Policy</li>
            <li onClick={() => handleNavigation("/RefundPolicy")}>Refund Policy</li>
          </ul>
        </div>

        {/* ADDRESS */}
        <div style={styles.column}>
          <h3 style={styles.heading}>Contact Address</h3>
          <div style={styles.address}>
            <b>Office Address:</b>
            <p>
              ZAPTODOOR PRIVATE LIMITED
              <br />
              G.Incube, Moti Mahal, Smart City Incubation Center,
              <br />
              Lashkar, Gwalior, Madhya Pradesh - 474007
            </p>

            {showMore && (
              <>
                <b>Registered Address:</b>
                <p>
                  ZAPTODOOR PRIVATE LIMITED
                  <br />
                  171, New Colony No.2, Birlana, Pole No.14, Birlanagar,
                  <br />
                  Birla Nagar, Gird, Gwalior - 474004, Madhya Pradesh, India
                </p>
              </>
            )}

            <button
              onClick={() => setShowMore(!showMore)}
              style={styles.viewBtn}
            >
              {showMore ? "Hide Registered Address" : "Registered Address"}
            </button>
          </div>
        </div>

        {/* SOCIAL */}
        <div style={styles.column}>
          <h3 style={styles.heading}>Social Links</h3>
          <div style={styles.socialWrap}>
            <a
              href="https://www.linkedin.com/company/zaptodoor"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.socialIcon}
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.instagram.com/zaptodoor"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.socialIcon}
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/zaptodoor"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.socialIcon}
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.youtube.com/@zaptodoor"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.socialIcon}
            >
              <FaYoutube />
            </a>
            <a
              href="https://twitter.com/zaptodoor"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.socialIcon}
            >
              <FaXTwitter />
            </a>
          </div>
        </div>
      </div>

      {/* BOTTOM */}
      <div style={styles.bottomSection}>
        <h2 style={styles.bottomText}>
          For better experience,
          <br />
          download the Zaptodoor app now
        </h2>

        <div style={styles.storeWrap}>
          {/* APP BUTTONS */}
          <div style={styles.storeButtons}>
            <a
              href="https://apps.apple.com/app/zaptodoor"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on App Store"
                style={styles.storeImg}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.zaptodoor"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                style={styles.storeImg}
              />
            </a>
          </div>

          {/* COPYRIGHT */}
          <p style={styles.copy}>© {currentYear} Zaptodoor Limited</p>
        </div>
      </div>
    </footer>
  );
}

// Horizontal Slider Component with backend images
function HorizontalSlider({ images, getImageUrl }) {
  const [index, setIndex] = useState(0);
  const [imageErrors, setImageErrors] = useState({});
  const moveWidth = 94; // 80(card) + 14(gap)

  // Create an array of image URLs from the certificates
  const imageUrls = images
    .map(cert => getImageUrl(cert.pic))
    .filter(url => url !== null);

  const handleImageError = (idx) => {
    setImageErrors(prev => ({ ...prev, [idx]: true }));
  };

  useEffect(() => {
    if (imageUrls.length === 0) return;
    
    const timer = setInterval(() => {
      setIndex((prev) => (prev === imageUrls.length - 1 ? 0 : prev + 1));
    }, 2200);
    return () => clearInterval(timer);
  }, [imageUrls.length]);

  if (imageUrls.length === 0) {
    return (
      <div style={sliderStyles.empty}>
        <p style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)" }}>
          No certificates available
        </p>
      </div>
    );
  }

  return (
    <div style={sliderStyles.wrapper}>
      <div
        style={{
          ...sliderStyles.track,
          transform: `translateX(-${index * moveWidth}px)`,
        }}
      >
        {/* Render images twice for infinite loop effect */}
        {[...imageUrls, ...imageUrls].map((img, i) => (
          <div key={i} style={sliderStyles.card}>
            {!imageErrors[i] ? (
              <img
                src={img}
                alt={`Certificate ${i + 1}`}
                style={sliderStyles.img}
                onError={() => handleImageError(i)}
              />
            ) : (
              <div style={sliderStyles.placeholder}>
                <span>📜</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const sliderStyles = {
  wrapper: {
    width: "174px",
    height: "90px",
    overflow: "hidden",
    borderRadius: "18px",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.08)",
    padding: "8px",
    backdropFilter: "blur(10px)",
  },
  track: {
    display: "flex",
    flexDirection: "row",
    gap: "14px",
    transition: "transform 0.7s ease",
  },
  card: {
    width: "80px",
    height: "80px",
    borderRadius: "16px",
    overflow: "hidden",
    background: "#fff",
    flexShrink: 0,
    boxShadow: "0 8px 18px rgba(0,0,0,0.35)",
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  placeholder: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    fontSize: "32px",
  },
  loading: {
    width: "174px",
    height: "90px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "18px",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.08)",
  },
  loader: {
    width: "30px",
    height: "30px",
    border: "2px solid rgba(255,255,255,0.2)",
    borderTop: "2px solid #fff",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  empty: {
    width: "174px",
    height: "90px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "18px",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.08)",
  },
};

const styles = {
  footer: {
    background: "linear-gradient(135deg, #000000 0%, #140021 35%, #2b004d 70%, #4c1d95 100%)",
    padding: "60px 70px 30px",
    fontFamily: "sans-serif",
    color: "#fff",
  },
  topSection: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "45px",
    borderBottom: "1px solid rgba(255,255,255,0.12)",
    paddingBottom: "45px",
  },
  logoSection: {
    minWidth: "260px",
    flex: 1.2,
  },
  logo: {
    width: "220px",
    marginBottom: "12px",
    cursor: "pointer",
  },
  column: {
    minWidth: "180px",
    flex: 1,
  },
  heading: {
    fontSize: "24px",
    fontWeight: "700",
    marginBottom: "18px",
    color: "#fff",
  },
  list: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    fontSize: "17px",
    lineHeight: "1.5",
    color: "rgba(255,255,255,0.78)",
    cursor: "pointer",
  },
  address: {
    fontSize: "16px",
    lineHeight: "1.7",
    color: "rgba(255,255,255,0.78)",
  },
  viewBtn: {
    marginTop: "12px",
    padding: "10px 18px",
    border: "none",
    borderRadius: "10px",
    background: "linear-gradient(135deg,#7c3aed,#9333ea)",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
    boxShadow: "0 6px 18px rgba(124,58,237,0.35)",
  },
  socialWrap: {
    display: "flex",
    gap: "18px",
    marginTop: "16px",
    flexWrap: "wrap",
  },
  socialIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.08)",
    backdropFilter: "blur(10px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "18px",
    textDecoration: "none",
    border: "1px solid rgba(255,255,255,0.08)",
    transition: "0.3s",
    cursor: "pointer",
  },
  bottomSection: {
    paddingTop: "35px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "30px",
  },
  bottomText: {
    fontSize: "34px",
    fontWeight: "700",
    color: "#fff",
    maxWidth: "620px",
    lineHeight: "1.4",
  },
  storeWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "18px",
    minWidth: "320px",
  },
  storeButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "18px",
    flexWrap: "wrap",
  },
  copy: {
    fontSize: "15px",
    color: "rgba(255,255,255,0.72)",
    textAlign: "center",
    margin: 0,
  },
  storeImg: {
    height: "65px",
    cursor: "pointer",
    filter: "drop-shadow(0 6px 12px rgba(0,0,0,0.35))",
  },
};

// Add keyframe animation for loader
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);